import React from 'react';
import Navbar from '../HomeComponent/Navbar';
import FooterComponent from '../Footer/FooterComponent';
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';

const ContactUs = () => {
    return (
        <>
            <Navbar />
            <div style={{ paddingTop: '100px', minHeight: '100vh', background: '#f8fafc', paddingBottom: '60px' }}>
                <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>

                    <div style={{ textAlign: 'center', marginBottom: '60px' }}>
                        <h1 style={{ fontSize: '3rem', fontWeight: 'bold', color: '#1e293b', marginBottom: '16px' }}>
                            Get in Touch
                        </h1>
                        <p style={{ fontSize: '1.25rem', color: '#64748b' }}>
                            Have questions? We'd love to hear from you.
                        </p>
                    </div>

                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '50px', alignItems: 'start' }}>

                        {/* Contact Info */}
                        <div>
                            <div style={{ background: 'white', padding: '40px', borderRadius: '16px', boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)', marginBottom: '30px' }}>
                                <h3 style={{ fontSize: '1.5rem', fontWeight: '600', color: '#1e293b', marginBottom: '24px' }}>Contact Information</h3>

                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
                                    <div style={{ background: '#eff6ff', padding: '12px', borderRadius: '50%', marginRight: '16px', color: '#3b82f6' }}>
                                        <FaEnvelope size={20} />
                                    </div>
                                    <div>
                                        <p style={{ fontSize: '0.875rem', color: '#64748b', marginBottom: '4px' }}>Email</p>
                                        <p style={{ fontSize: '1rem', color: '#1e293b', fontWeight: '500' }}>support@toxbox.ai</p>
                                    </div>
                                </div>

                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
                                    <div style={{ background: '#f0fdf4', padding: '12px', borderRadius: '50%', marginRight: '16px', color: '#22c55e' }}>
                                        <FaPhoneAlt size={20} />
                                    </div>
                                    <div>
                                        <p style={{ fontSize: '0.875rem', color: '#64748b', marginBottom: '4px' }}>Phone</p>
                                        <p style={{ fontSize: '1rem', color: '#1e293b', fontWeight: '500' }}>+1 (555) 123-4567</p>
                                    </div>
                                </div>

                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <div style={{ background: '#fef2f2', padding: '12px', borderRadius: '50%', marginRight: '16px', color: '#ef4444' }}>
                                        <FaMapMarkerAlt size={20} />
                                    </div>
                                    <div>
                                        <p style={{ fontSize: '0.875rem', color: '#64748b', marginBottom: '4px' }}>Office</p>
                                        <p style={{ fontSize: '1rem', color: '#1e293b', fontWeight: '500' }}>123 AI Street, San Francisco, CA</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Contact Form */}
                        <div style={{ background: 'white', padding: '40px', borderRadius: '16px', boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)' }}>
                            <h3 style={{ fontSize: '1.5rem', fontWeight: '600', color: '#1e293b', marginBottom: '24px' }}>Send us a Message</h3>

                            <form>
                                <div style={{ marginBottom: '20px' }}>
                                    <label style={{ display: 'block', fontSize: '0.875rem', color: '#475569', marginBottom: '8px' }}>Name</label>
                                    <input type="text" placeholder="Your Name" style={{ width: '100%', padding: '12px', borderRadius: '8px', border: '1px solid #e2e8f0', outline: 'none' }} />
                                </div>
                                <div style={{ marginBottom: '20px' }}>
                                    <label style={{ display: 'block', fontSize: '0.875rem', color: '#475569', marginBottom: '8px' }}>Email</label>
                                    <input type="email" placeholder="you@company.com" style={{ width: '100%', padding: '12px', borderRadius: '8px', border: '1px solid #e2e8f0', outline: 'none' }} />
                                </div>
                                <div style={{ marginBottom: '20px' }}>
                                    <label style={{ display: 'block', fontSize: '0.875rem', color: '#475569', marginBottom: '8px' }}>Message</label>
                                    <textarea rows="4" placeholder="How can we help?" style={{ width: '100%', padding: '12px', borderRadius: '8px', border: '1px solid #e2e8f0', outline: 'none', resize: 'vertical' }}></textarea>
                                </div>
                                <button type="button" style={{ width: '100%', padding: '14px', borderRadius: '8px', background: '#1e293b', color: 'white', fontWeight: 'bold', border: 'none', cursor: 'pointer' }}>
                                    Send Message
                                </button>
                            </form>
                        </div>

                    </div>

                </div>
            </div>
            <FooterComponent />
        </>
    );
};

export default ContactUs;
